(function () {
  'use strict';

  angular.module('app').component('receivedPaymentPage', receivedPaymentDetailCtrl());

  function receivedPaymentDetailCtrl() {
    return {
      bindings: {},
      controller: ReceivedPaymentDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/received-payments/received-payment-page.component.html',
    };
  }

  ReceivedPaymentDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'SessionService',
    'ReceivedPaymentService',

    // Angular downgraded service
    'companyService',
  ];

  function ReceivedPaymentDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    SessionService,
    ReceivedPaymentService,

    // Angular downgraded service
    companyService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_receivedpayment_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    // Methods
    vm.onReceivedPaymentSaved = onReceivedPaymentSaved;
    vm.onReceivedPaymentCanceled = onReceivedPaymentCanceled;

    // Initializers
    getReceivedPayment();
    getCompany();

    function getReceivedPayment() {
      if (itemId) {
        // edit
        vm.loadingItem = true;
        ReceivedPaymentService.getReceivedPayment(itemId).then(function (data) {
          vm.receivedPayment = data;
          vm.loadingItem = false;
        });
      } else {
        vm.receivedPayment = {};
      }
    }

    function getCompany() {
      var companyId = SessionService.getSelectedAccountCompany().id;

      // Try to respond only basic json from API
      vm.loadingCompany = true;
      companyService.getCompany(companyId, { skip_check_role: true }).subscribe((response) => {
        vm.company = response;

        vm.company.payment_methods = vm.company.payment_methods.filter(
          (method) => method.status == true
        );

        vm.loadingCompany = false;
      });
    }

    function onReceivedPaymentSaved(item) {
      $location.path(`/received_payments/${item.id}`);
    }

    function onReceivedPaymentCanceled() {
      $location.path('/received_payments');
    }
  }
})();
